import { render, staticRenderFns } from "./progressing.vue?vue&type=template&id=72180a0e&lang=pug&"
import script from "./progressing.vue?vue&type=script&lang=js&"
export * from "./progressing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports